export enum MaxFieldLength {
  HouseNumber = 10,
  IdCardNumber = 10,
  MB = 13,
  OIB = 17,
  Phone = 30,
  Name = 30,
  ShortName = 40,
  IBAN = 40,
  ContactPerson = 45,
  IdCardIssuedBy = 50,
  StreetName = 70,
  MBS = 100,
  Email = 100,
  FullName = 500,
  Message = 5000,
  tfaCode = 6,
}
